export default [
  {
    path: '/dappsa/tablero-indicadores',
    name: 'tablero-indicadores',
    component: () => import('@/views/dappsa/tablero-indicadores/main.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/dappsa/tablero-indicadores-detalle/:id',
    name: 'tablero-indicadores-detalle',
    component: () => import('@/views/dappsa/tablero-indicadores/ReportDetalle.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
]
